import GithubSlugger from "github-slugger";

const slugger = new GithubSlugger();

export function slug(str: string) {
  slugger.reset();
  return slugger.slug(str);
}
